import { CREATE_PACKING_ENTRY_DETAIL_FAILURE, CREATE_PACKING_ENTRY_DETAIL_REQUEST, CREATE_PACKING_ENTRY_DETAIL_SUCCESS, CREATE_PACKING_ENTRY_FAILURE, CREATE_PACKING_ENTRY_REQUEST, CREATE_PACKING_ENTRY_SUCCESS, CREATE_USERFORM_PACKING_TABLE_LIST_DATA, CREATE_USER_FORM_PACKING_ENTRY, DELETE_PACKING_ENTRY_DETAIL_FAILURE, DELETE_PACKING_ENTRY_DETAIL_REQUEST, DELETE_PACKING_ENTRY_FAILURE, DELETE_PACKING_ENTRY_REQUEST, FETCH_PACKING_ENTRY_DATA_FAILURE, FETCH_PACKING_ENTRY_DATA_REQUEST, FETCH_PACKING_ENTRY_DATA_SUCCESS, FETCH_PACKING_ENTRY_DETAIL_DATA_FAILURE, FETCH_PACKING_ENTRY_DETAIL_DATA_REQUEST, FETCH_PACKING_ENTRY_DETAIL_DATA_SUCCESS, FETCH_PACKING_ENTRY_TABLE_DATA_REQUEST, FETCH_PACKING_ENTRY_TABLE_DATA_SUCCESS, FETCH_SINGLE_PACKING_ENTRY_DATA_FAILURE, FETCH_SINGLE_PACKING_ENTRY_DATA_REQUEST, FETCH_WAREHOUSE_INWARD_APPROVAL_ACCEPT_OR_REJECT_FAILURE, FETCH_WAREHOUSE_INWARD_APPROVAL_ACCEPT_OR_REJECT_REQUEST, FETCH_WAREHOUSE_INWARD_APPROVAL_ACCEPT_OR_REJECT_SUCCESS, FETCH_WAREHOUSE_STYLE_NUMBER_DATA_ID_FAILURE, FETCH_WAREHOUSE_STYLE_NUMBER_DATA_ID_REQUEST, FETCH_WAREHOUSE_STYLE_NUMBER_DATA_ID_SUCCESS, FFETCH_PACKING_ENTRY_TABLE_DATA_FAILURE, NAVIGATE_PACKING_ENTRY_DETAILS, NAVIGATE_PACKING_ENTRY_HEADER, PACKING_ENTRY_USERFORM_RESET, SET_UNIT_NAME_PACKING_ENTRY } from "./packingEntry.actionsType";


export const PACKING_ENTRY = 'packingEntry'


let initialState = {
    loading: false,
    userform: {
        startDate: new Date().setDate(new Date().getDate() - 15),
        endDate: new Date(),
        unitId: 1,
        fldIsReject: false,
        fldFKSaleOrder: '',
        fldFKWHStyleMaster: '',
    },
    activeKey: 1,
    packingdata: [],
    packingListData: [],
    packingListDetaildata: [],
    isPackingEntry: false,
    packingEntrySelectedValue: {},
    detailsId: [],
    packingDetailsId: '',
    newWareHouseStyleData: [],
    wareHouseDetailresponse: ''
};

export let packingEntryReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_PACKING_ENTRY_DATA_REQUEST:
        case FETCH_PACKING_ENTRY_TABLE_DATA_REQUEST:
        case CREATE_PACKING_ENTRY_REQUEST:
        case FETCH_PACKING_ENTRY_DETAIL_DATA_REQUEST:
        case DELETE_PACKING_ENTRY_REQUEST:
        case DELETE_PACKING_ENTRY_DETAIL_REQUEST:
        case FETCH_SINGLE_PACKING_ENTRY_DATA_REQUEST:
        case CREATE_PACKING_ENTRY_DETAIL_REQUEST:
        case FETCH_WAREHOUSE_STYLE_NUMBER_DATA_ID_REQUEST:
        case FETCH_WAREHOUSE_INWARD_APPROVAL_ACCEPT_OR_REJECT_REQUEST:
            return {
                ...state,
                loading: true,
            };

        case FETCH_PACKING_ENTRY_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                packingdata: updatePayload,
            };
        case FETCH_PACKING_ENTRY_TABLE_DATA_SUCCESS:
            const updatedPackingListData = updatePayload?.map((item) => {
                const fldActualBox = item.fldPerBoxQuantity
                    ? Number(Math.floor(item.fldBalance2PackQuantity / item.fldPerBoxQuantity)) || 0
                    : 0;

                //const fldActualBox = parseInt(fldPkdNoofBoxes) || 0;
                const fldCurrentPkdQuantity = Number(item.fldPerBoxQuantity * fldActualBox);
                const fldBalanceQuantity = Number(item.fldBalance2PackQuantity - fldCurrentPkdQuantity);
                const fldGoodQuantity = Number(fldBalanceQuantity);

                return {
                    ...item,
                    //fldPkdNoofBoxes,
                    fldActualBox,
                    fldCurrentPkdQuantity,
                    fldBalanceQuantity,
                    fldGoodQuantity,
                };
            });

            return {
                ...state,
                loading: false,
                packingListData: updatedPackingListData,
            };
        case FETCH_PACKING_ENTRY_DETAIL_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                packingListDetaildata: updatePayload,
            };
        case CREATE_PACKING_ENTRY_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId,
                    fldFKSaleOrder: state.userform.fldFKSaleOrder,
                    fldFKWHStyleMaster: state.userform.fldFKWHStyleMaster,
                    fldIsReject: false,

                },
                detailsId: updatePayload,
            };
        case FETCH_SINGLE_PACKING_ENTRY_DATA_FAILURE:
            return {
                ...state,
                loading: false,
                userform: {
                    ...updatePayload, startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                }
            };
        case CREATE_PACKING_ENTRY_DETAIL_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    ...updatePayload, startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId,
                    fldFKSaleOrder: '',
                    fldFKWHStyleMaster: '',
                },
                wareHouseDetailresponse: updatePayload,
            };
        case FETCH_WAREHOUSE_STYLE_NUMBER_DATA_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                newWareHouseStyleData: updatePayload,
            };
        case FETCH_WAREHOUSE_INWARD_APPROVAL_ACCEPT_OR_REJECT_SUCCESS:
            return {
                ...state,
                loading: false,
                approvalorRejectionData: updatePayload,
            };
        case FETCH_PACKING_ENTRY_DATA_FAILURE:
        case FFETCH_PACKING_ENTRY_TABLE_DATA_FAILURE:
        case CREATE_PACKING_ENTRY_FAILURE:
        case FETCH_PACKING_ENTRY_DETAIL_DATA_FAILURE:
        case DELETE_PACKING_ENTRY_FAILURE:
        case DELETE_PACKING_ENTRY_DETAIL_FAILURE:
        case FETCH_SINGLE_PACKING_ENTRY_DATA_FAILURE:
        case CREATE_PACKING_ENTRY_DETAIL_FAILURE:
        case FETCH_WAREHOUSE_STYLE_NUMBER_DATA_ID_FAILURE:
        case FETCH_WAREHOUSE_INWARD_APPROVAL_ACCEPT_OR_REJECT_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_PACKING_ENTRY:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                },
            };
        case CREATE_USERFORM_PACKING_TABLE_LIST_DATA:
            return {
                ...state,
                packingListData: payload
            };
        case SET_UNIT_NAME_PACKING_ENTRY:
            return {
                ...state,
                unitId: payload
            };
        case PACKING_ENTRY_USERFORM_RESET:
            return {
                ...state,
                userform: {
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId,
                    fldIsReject: false,
                    fldFKSaleOrder: '',
                    fldFKWHStyleMaster: '',

                },
                detailsId: [],
                packingDetailsId: '',
                packingListData: [],
                wareHouseDetailresponse: ''
            };
        case NAVIGATE_PACKING_ENTRY_DETAILS:
            return {
                ...state,
                isPackingEntry: true,
                loading: false,
                packingEntrySelectedValue: updatePayload.packingEntrySelectedValue
            };
        case NAVIGATE_PACKING_ENTRY_HEADER:
            return {
                ...state,
                isPackingEntry: false
            };
        default:
            return state;
    }
};